import ModalMaster from '../components/ModalMaster';
import FormContacts from '../components/forms/FormContacts';
import FormVacancy from '../components/forms/FormVacancy';
import TradeForm from '../components/forms/TradeForm';
import PollList from '../components/poll/PollList';
import FormVacancyStudent from "../components/forms/FormVacancyStudent";

if (document.getElementById('main-modal')) {
    new Vue({
        el: '#main-modal',
        data() {
            return {
                modalData: window.modal,
            }
        },
        components: {
            ModalMaster
        },
    });

    $(document).on('click', '.main-page-callback, .btn-callback, .call-btn', function () {
        window.modal.type = 'callback';
        $('#main-modal').modal('show');
    });

    $(document).on('click', '.login-btn', function () {
        window.modal.type = 'login';
        $('#main-modal').modal('show');
    });

    $(document).on('click', '.media', function () {
        window.modal.type = 'video';
        $('#main-modal').modal('show');
    });

    $(document).on('click', '.vacancy-form-btn', function () {
        window.modal.type = 'vacancies';
        $('#main-modal').modal('show');
    });
}

if (document.getElementById('contacts-form')) {
    let vm = new Vue({
        el: '#contacts-form',
        components: {
            FormContacts
        },
    });
}
if (document.getElementById('poll-list')) {
    let vm = new Vue({
        el: '#poll-list',
        components: {
            PollList
        },
    });
}
if (document.getElementById('vacancy-form')) {
    let vm = new Vue({
        el: '#vacancy-form',
        components: {
            FormVacancy
        },
    });
}
if (document.getElementById('vacancy-form-student')) {
    let vm = new Vue({
        el: '#vacancy-form-student',
        components: {
            FormVacancyStudent
        },
    });
}
if (document.getElementById('trade-form')) {
    let vm = new Vue({
        el: '#trade-form',
        components: {
            TradeForm
        },
    });
}


if (document.getElementsByClassName('vacancy-form-id')) {
    let wl = document.getElementsByClassName('vacancy-form-id');

    Array.from(wl).forEach(function (item) {
            new Vue({
                el: item,
                components: {
                    FormVacancy
                }
            });
        }
    );
}